import SkeletonLoader from './index';

const COLUMN_COUNT = 8;
const ROW_COUNT = 10;

const GameDashboardSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Top bar: search + filter + action button */}
      <div className="flex items-center justify-between gap-4 ps-1">
        <div className="flex items-center gap-4 flex-1">
          <SkeletonLoader className="h-12 w-72 rounded-lg" variant="rect" />
          <SkeletonLoader className="h-12 w-24 rounded-lg" variant="rect" />
        </div>
        <SkeletonLoader className="h-12 w-40 rounded-lg" variant="rect" />
      </div>

      {/* Table card */}
      <div className="flex flex-col border border-neutral-200 rounded-2xl overflow-hidden bg-white">
        {/* Section heading */}
        <div className="px-4 pt-4 pb-2">
          <SkeletonLoader className="h-5 w-32" variant="rect" />
        </div>

        {/* Header row */}
        <div className="flex items-center gap-4 px-4 py-3 bg-neutral-100">
          <SkeletonLoader className="h-4 w-5" variant="rect" />
          {Array.from({ length: COLUMN_COUNT }).map((_, i) => (
            <SkeletonLoader key={i} className="h-4 flex-1" variant="rect" />
          ))}
        </div>

        {/* Data rows */}
        {Array.from({ length: ROW_COUNT }).map((_, row) => (
          <div
            key={row}
            className="flex items-center gap-4 px-4 py-3 border-b border-neutral-200"
          >
            {/* Expand icon */}
            <SkeletonLoader className="h-5 w-5" variant="rect" />
            {/* Checkbox + icon + name */}
            <div className="flex items-center gap-3 flex-1">
              <SkeletonLoader className="h-5 w-5" variant="rect" />
              <SkeletonLoader className="h-10 w-10 rounded-lg" variant="rect" />
              <SkeletonLoader className="h-4 w-28" variant="rect" />
            </div>
            {/* Remaining columns */}
            {Array.from({ length: COLUMN_COUNT - 1 }).map((_, col) => (
              <SkeletonLoader key={col} className="h-4 flex-1" variant="rect" />
            ))}
          </div>
        ))}

        {/* Pagination skeleton */}
        <div className="flex items-center justify-between px-4 py-3 border-t border-neutral-200">
          <SkeletonLoader className="h-4 w-44" variant="rect" />
          <div className="flex gap-3">
            <SkeletonLoader className="h-10 w-25 rounded-lg" variant="rect" />
            <SkeletonLoader className="h-10 w-25 rounded-lg" variant="rect" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameDashboardSkeleton;
